// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notifications_wrapper__1Dm00","todos":"notifications_todos__37r5k","surveys":"notifications_surveys__CsrvB"};